<template>
	<div class="flex flex-col h-screen w-screen overflow-hidden">
		<MaintenancePanel ref="maintenancePanel" show-if-status="in_progress"/>

		<div class="flex flex-grow w-full min-h-0 overflow-hidden bg-neutral">
			<div class="relative w-0 lg:w-2/5 invisible lg:visible" :class="heroBgColor">
				<img :src="heroPath" alt="Logo" class="absolute" :class="heroClassData" />
			</div>
			<div class="flex flex-col flex-grow py-12 px-12 overflow-y-auto bg-neutral md:pt-20 md:pb-10 md:px-46 max-w-[940px] md:mx-0">
				<div>
					<slot></slot>
				</div>
				<p v-if="showContactUsText" class="text-center text-grayscale-body mt-10 leading-6">Need help? <span class="clickable-text" @click="showContactUs = true">Contact us</span>.
				</p>
			</div>
		</div>

		<Teleport to="html">
			<ContactUsModal v-if="showContactUs" :show="showContactUs" :horizontal-alignment="ModalHorizontalAlignment.End" :vertical-alignment="ModalVerticalAlignment.Bottom" @dismiss="showContactUs = false" />
		</Teleport>
	</div>
</template>

<script setup >
import ContactUsModal from '@/views/Contact/ContactUsModal.vue'
import { onBeforeMount, onMounted, ref } from 'vue'
import { Tenants } from '@/models/tenants/Tenants'
import { Banner } from '@/models/utils/Toaster.js'
import { userApi } from '@/api/User/UserApi.js'
import { ModalHorizontalAlignment, ModalVerticalAlignment } from '@/components/Alerts/ModalAlignment.js'
import MaintenancePanel from '@/components/Misc/MaintenancePanel.vue'

const showContactUs = ref(false)
const tenant = ref(null)
const heroPath = ref('')
const heroBgColor = ref('')
const heroClassData = ref('')

defineProps({
	showContactUsText: { type: Boolean, default: true }
})

const banner = new Banner();

onBeforeMount(() => {
	banner.clear()
	userApi.refreshUserData()
})

onMounted(() => {
	tenant.value = Tenants.getTenant()
	heroPath.value = new URL(`../assets/images/theme/${tenant.value.hero.image}`, import.meta.url).href
	heroBgColor.value = tenant.value.hero.background
	heroClassData.value = tenant.value.hero.classData
})
</script>